/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/map-pinned
 */
import { default as DefaultIcon } from '~icons/lucide/map-pinned';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const MapPinnedIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
